/**
 * Every built-in sketch-object type as an editable data spec — the same
 * drawing, params, handles and coupled values as the code in ../../defs
 * (each one is checked against its built-in by the tests in __tests__).
 * "Duplicate to edit" starts from these, and they double as worked examples
 * of the spec's rules: repeats, formulas, copies by formula, linked values.
 */

import { DATA_BUILTIN_DIMENSION_SPECS, DATA_BUILTIN_OBJECT_SPECS, type ObjectDefinitionSpec } from 'shared-types';
import { bathSpec } from './bath';
import { chairSpec } from './chair';
import { deskSpec } from './desk';
import { showerSpec } from './shower';
import { tableSpec } from './table';

/** Built-in type id → its spec. */
export const BUILTIN_OBJECT_SPECS: Readonly<Record<string, ObjectDefinitionSpec>> = {
  // The pure-data ones live in shared-types (the server shows them to the object AI).
  ...DATA_BUILTIN_OBJECT_SPECS,
  bath: bathSpec,
  shower: showerSpec,
  chair: chairSpec,
  desk: deskSpec,
  table: tableSpec,
  // The built-in dimensions are data only (registered from these very specs).
  ...Object.fromEntries(DATA_BUILTIN_DIMENSION_SPECS.map(({ id, spec }) => [id, spec])),
};
